<template>
    <div>
        <div name="breadcrumb-layout" class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>设备维保统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div name="org-tree" class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :showIncludeSubComs="true" :initIncludeSubComs="includeSubComs" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_sort_area" :confKey="confKey" :queryOnLoad="queryOnLoad" :configAuto="true" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        <div name="btns" class="simple-row">
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" v-if="thisComId != null" @click="download()">
                    <span>导出excel</span>
                </button>
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="showStaticFieExp()">
                    <span>统计字段说明</span>
                </button>
            </div>
        </div>
        <div name="table-list">
            <swb-result-table name="result_table" :confKey="confKey" :configAuto="true" ref="result_table" :needPager="true" :rowNoShow="false" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
        </div>
    </div>
</template>

<script>

    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { setAssetsGroupDevcFilter } from '../asset/selectDlg'
    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { loadRetailerShopTagList, loadRetailerDevcGroupCascList } from '../retailer/asset-comn'
    //
    import statisApi from '../../api/statisWork'
    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    import SwbResultTable from '../query/ResultTable'
    Vue.regist(SwbResultTable);

    import SwbDeviceMalfunctionStatisList from '../retailer/DeviceMalfunctionStatisList.vue';
    Vue.regist(SwbDeviceMalfunctionStatisList);

    import  { showStatisFieExplDlg } from './statisDig';

    export default {
        name: 'swb-device-shop-maintain-statis-list',
        path: '/shop/device/svcNo/maintain/statis/list',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '设备维修机构对比统计表',
        data: function () {
            return {
                confKey: "device-shop-maintain-statis-list-report",
                tableHeight: 300, //表格高度
                queryOnLoad: true,
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                assetTypeMap: getEnumMap('assetType', 'value2text'),
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                thisComId: null,
                includeSubComs: false,
                retailerShopCom1: null,
                retailerShopCom2: null,
                retailerShopCom3: null,
                retailerShopCom4: null,
                thisComLevel: null,
                comInfo: {},
                comName: null,
                itemList: [],
                userContext: {
                    scopeEntity: {}
                },
                shopFlag: false,
                loading: false,
                treeCollapse: true,
                exportParams: {},
                showQuery: true,
                resultColConf: null,
                currentDate: new Date(),
                lastPageNumber: null,
                tmpNo: null,
                brandName: null,
                devcGroupId: null,
                useMonth: null,
                createTimeFrom: null,
                createTimeTo: null,
                fromReport: false,
                scopeEntity: null,
                mgmtSmlAreaId: null
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="table-list"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
                console.log("qw1" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="breadcrumb-layout"], [name="org-tree"], [name="query-sort-area"], [name="btns"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.tmpNo = this.$route.query.tmpNo || null;
            this.catName = this.$route.query.catName || null;
            this.brandName = this.$route.query.brandName || null;
            this.devcGroupId = this.$route.query.groupId || null;
            this.useMonth = this.$route.query.useMonth || null;
            this.createTimeFrom = this.$route.query.createTimeStart || null;
            this.createTimeTo = this.$route.query.createTimeEnd || null;
            this.fromReport = this.$route.query.fromReport || false;
            if(!Utils.isNoB(this.tmpNo) || Utils.isTrue(this.fromReport) && (!Utils.isNoB(this.brandName) || !Utils.isNoB(this.catName) || !Utils.isNoB(this.devcGroupId) || !Utils.isNoB(this.createTimeFrom) || !Utils.isNoB(this.createTimeTo))) {
                this.includeSubComs = true;
            }
            //
            this.getUserInfoByContext();
        },
        methods: {
            onConfigReady: function () {
                let self = this;
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField("retailerShopTagId", dataList);
                });
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
                if(!Utils.isNoB(self.tmpNo)) {
                    let query_model_ctrl = this.$refs['query_sort_area'];
                    let data = {value: self.tmpNo};
                    let fieldInfo = {};
                    fieldInfo["tmpNo"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
                if(!Utils.isNoB(self.devcGroupId)) {
                    let query_model_ctrl1 = this.$refs['query_sort_area'];
                    let devcGroupData = {value: self.devcGroupId};
                    let devcGroupInfo = {};
                    devcGroupInfo["devcGroupId"] = devcGroupData;
                    query_model_ctrl1.updateFields(devcGroupInfo);
                }
                if(!Utils.isNoB(self.brandName)) {
                    let query_model_ctrl2 = this.$refs['query_sort_area'];
                    let brandData = {value: self.brandName};
                    let brandInfo = {};
                    brandInfo["brandName"] = brandData;
                    query_model_ctrl2.updateFields(brandInfo);
                }
                if(!Utils.isNoB(self.catName)) {
                    let query_model_ctrl3 = this.$refs['query_sort_area'];
                    let catData = {value: self.catName};
                    let catInfo = {};
                    catInfo["catName"] = catData;
                    query_model_ctrl3.updateFields(catInfo);
                }
                if(!Utils.isNoB(self.createTimeFrom) || !Utils.isNoB(self.createTimeTo)) {
                    let query_model_ctrl4 = this.$refs['query_sort_area'];
                    let createTimeData = {
                        value: {
                            from: self.createTimeFrom,
                            to: self.createTimeTo
                        }
                    };
                    let createTimeInfo = {};
                    createTimeInfo["createTime"] = createTimeData;
                    query_model_ctrl4.updateFields(createTimeInfo);
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_sort_area'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable(){
                let self = this;
                let query_sort_area = this.$refs['query_sort_area'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_sort_area);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'tillGapDays': function (row, colName, colValue, rowIndex, colConf) {
                        // 平均故障间隔(天)
                        if(row.tillGapMinutes == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + (row.tillGapMinutes / 60 / 24).toFixed(2) + '</span>';
                        }
                    },
                    'amount': function (row, colName, colValue, rowIndex, colConf) {
                        // 总维保费(元)
                        if(row.amount == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + (row.amount).toFixed(2) + '</span>';
                        }
                    },
                    'repairTimes': function (row, colName, colValue, rowIndex, colConf) {
                        // 维修次数
                        if(row.repairTimes == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.repairTimes + '</span>';
                        }
                    },
                    'servRepaireHours': function (row, colName, colValue, rowIndex, colConf) {
                        // 平均维修时长(小时)
                        if(row.servRepaireTimeMi == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + (row.servRepaireTimeMi / 60).toFixed(2) + '</span>';
                        }
                    },
                    'productAmount': function (row, colName, colValue, rowIndex, colConf) {
                        // 总维修费(元)
                        if(row.productAmount == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + row.productAmount.toFixed(2) + '</span>';
                        }
                    },
                    'productAvgAmount': function (row, colName, colValue, rowIndex, colConf) {
                        // 平均维修费(元)
                        if(row.productAvgAmount == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + row.productAvgAmount.toFixed(2) + '</span>';
                        }
                    },
                    'maintCount': function (row, colName, colValue, rowIndex, colConf) {
                        // 保养次数
                        if(row.maintCount == null) {
                            return '<span>0</span>';
                        } else {
                            return '<span>' + row.maintCount + '</span>';
                        }
                    },
                    'tillGapMaintDays': function (row, colName, colValue, rowIndex, colConf) {
                        // 平均保养间隔(天)
                        if(row.tillGapMainMinutes == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + (row.tillGapMainMinutes / 60 / 24).toFixed(2) + '</span>';
                        }
                    },
                    'servMaintHours': function (row, colName, colValue, rowIndex, colConf) {
                        // 平均保养时长(小时)
                        if(row.servMainTimeMi == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + (row.servMainTimeMi / 60 ).toFixed(2) + '</span>';
                        }
                    },
                    'mainAmount': function (row, colName, colValue, rowIndex, colConf) {
                        // 总保养费(元)
                        if(row.mainAmount == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + (row.mainAmount).toFixed(2) + '</span>';
                        }
                    },
                    'mainAvgAmount': function (row, colName, colValue, rowIndex, colConf) {
                        // 平均保养费(元)
                        if(row.mainAvgAmount == null) {
                            return '<span>0.00</span>';
                        } else {
                            return '<span>' + (row.mainAvgAmount).toFixed(2) + '</span>';
                        }
                    },
                    'assetType': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.assetTypeMap[row.assetType] + '</span>';
                    },
                });
            },
            notityChange: function (eventData) {
                this.mgmtSmlAreaId = null;
                if(Utils.isTrue(eventData.mgmtFlag)) {
                    let scopeEntity = this.scopeEntity;
                    this.thisComLevel = scopeEntity.comLevel;
                    this.thisComId = scopeEntity.comId;
                    this.includeSubComs = true;
                    this.mgmtSmlAreaId = eventData.id;
                } else {
                    if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                        this.thisComLevel = eventData.level;
                        this.thisComId = eventData.id;
                        this.includeSubComs = eventData.includeSubComs;
                    }
                }
                this.getShopDeviceStatisList();
            },
            queryHandler(queryModel) {
                //缓存查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getShopDeviceStatisList();
            },
            getUserInfoByContext: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        let userContext = result.data;
                        self.scopeEntity = userContext.scopeEntity;
                        self.shopFlag = userContext.scopeEntity.shopFlag;
                        self.userContext = userContext;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);

                let resultTable = this.$refs.result_table;
                console.log(resultTable.getPagination());

                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getShopDeviceStatisList();
            },
            getShopDeviceStatisList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);

                filterItems.comId = this.thisComId;
                filterItems.comLevel = this.thisComLevel;
                filterItems.includeSubComs = this.includeSubComs;
                filterItems.mgmtSmlAreaId = this.mgmtSmlAreaId;
                //
                let tmpNo = this.$route.query.tmpNo || null;
                if(!Utils.isNoB(tmpNo)) {
                    this.includeSubComs = true;
                    filterItems.includeSubComs = true;
                    filterItems.tmpNo = tmpNo;
                }
                if(Utils.isTrue(this.fromReport) && !Utils.isNoB(this.devcGroupId)) {
                    this.includeSubComs = true;
                    filterItems.includeSubComs = true;
                    filterItems.devcGroupId = this.devcGroupId;
                }
                if(Utils.isTrue(this.fromReport) && !Utils.isNoB(this.catName)) {
                    this.includeSubComs = true;
                    filterItems.includeSubComs = true;
                    filterItems.catName = this.catName;
                }
                if(Utils.isTrue(this.fromReport) && !Utils.isNoB(this.brandName)) {
                    this.includeSubComs = true;
                    filterItems.includeSubComs = true;
                    filterItems.brandName = this.brandName;
                }
                if(Utils.isTrue(this.fromReport) && !Utils.isNoB(this.useMonth)) {
                    this.includeSubComs = true;
                    filterItems.includeSubComs = true;
                    filterItems.useMonth = this.useMonth;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                this.exportParams = postData;
                //
                let loading = MsgBox.loading();
                statisApi.getShopDeviceProductMaintStatisList(postData, function (result, jqXhr) {
                    loading.close();
                    if(result.type == 'info') {
                        let resultData = result.data;
                        //
                        self.itemList = resultData.rows;
                        let pagination = resultData.pagination;
                        self.totalCount = pagination.totalCount;
                        self.renderTable(self.itemList, pagination);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, pagination) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: pagination,
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            searchServcReqVoucher: function (deviceId) {
                this.$router.push({
                    query: {
                        deviceId: deviceId,
                        back: true
                    },
                    path: SwbDeviceMalfunctionStatisList.path,
                });
            },
            showTreeCollapse: function (treeCollapse) {
//                console.log(treeCollapse);
                this.treeCollapse = treeCollapse;
            },
            download: function () {
                let self = this;
                let pageSize = 1000;
                let pages = Math.ceil(this.totalCount / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let pages = Math.ceil(this.totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "设备维保统计" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '设备维保统计-下载 | 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/statis/work/shop/device/product/maint/statis/list/export/do";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let exportParams = this.exportParams;
                filterItems = exportParams.filterItems;
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
//
            //统计字段解释说明
            showStaticFieExp: function () {
                let theme = "设备维保统计";
                showStatisFieExplDlg(theme);
            },
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/statisWork/DeviceShopMaintainStatisList.vue